import Styled from 'styled-components';

export const Container = Styled.div`
  border-radius: 8px;
  padding: 24px 0;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = Styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProductName = Styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
  line-height: 1.3;
`;

export const StatusTracker = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;

export const StatusStep = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  position: relative;
  
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
`;

export const StatusIcon = Styled.div`
  width: 32px;
  height: 32px;
  min-height: 32px;
  max-width: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.completed ? 'var(--primary-color)' : 'white'};
  border: 2px solid ${props => props.completed ? 'var(--primary-color)' : '#E0E0E0'};
  flex-shrink: 0;
  transition: background-color 0.3s ease;
  z-index: 1;

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`;

export const StatusLine = Styled.div`
  position: absolute;
  top: 16px;
  left: calc(50% + 16px);
  right: calc(-50% + 16px);
  height: 2px;
  background-color: ${props => props.completed ? 'var(--primary-color)' : '#E0E0E0'};
  transition: background-color 0.3s ease;
  
  @media (max-width: 768px) {
    top: 14px;
    left: calc(50% + 14px);
    right: calc(-50% + 14px);
  }
`;

export const StatusLabel = Styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--primary-color);
  line-height: 1.4;
  margin-top: 4px;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const StatusDate = Styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--primary-color);
  margin-top: 2px;
  
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const ProductDetails = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ProductRow = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const ProductDescription = Styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--primary-color);
  opacity: 0.6;
  margin: 0;
  line-height: 1.5;
  flex: 1;
`;

export const ProductPrice = Styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-color);
  white-space: nowrap;
  text-align: right;
`;

export const Divider = Styled.hr`
  border: none;
  border-top: 1px solid #D7D7DB;
  margin: 8px 0;
`;

export const TotalRow = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Label = Styled.span`
  font-size: 14px;
  font-weight: ${props => props.isBold ? '600' : '400'};
  color: var(--primary-color);
`;

export const Value = Styled.span`
  font-size: 14px;
  font-weight: ${props => props.isBold ? '600' : '500'};
  color: var(--primary-color);
  white-space: nowrap;
  text-align: right;
`;

export const NoTrackingContainer = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NoTrackingTitle = Styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
`;

export const NoTrackingMessage = Styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--primary-color);
  margin: 0;
  line-height: 1.5;

  strong {
    font-weight: 600;
  }
`;